import { Builder } from '../api/builder'
import { DemandResource } from '../api/config'

export const viewDemandList = Builder(filters => DemandResource().get('/my', {params: filters}))
export const viewDemandDetail = Builder(id => DemandResource().get('/detail', {id: id}))
export const createDemand = Builder(info => DemandResource().post('', info))
export const revokeDemand = Builder(info => DemandResource().post('/revoke', info))
export const countDemand = Builder(() => DemandResource().get('/index'))